"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _memberManagement = require("@/api/member/memberManagement.js");
var _decorateConfigItem = require("@/api/decorate/decorateConfigItem.js");
var _shopList = require("@/api/shop/shopList.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'StoredValuePopupConfiguration',
  props: {
    pageKey: {
      type: String,
      default: ''
    },
    moduleKey: {
      type: String,
      default: ''
    },
    xcxType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      // 列表相关
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      loading: false,
      // 对话框相关
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      currentId: null,
      // 表单数据
      formData: {
        name: '',
        recommendDesc: '',
        category: 0,
        type: 0,
        enable: true,
        shopids: []
      },
      timeRange: [],
      // 合并的时间范围
      // 表单验证规则
      rules: {
        category: [{
          required: true,
          message: '请选择分类',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入储值档位',
          trigger: 'blur',
          validator: this.validateName
        }],
        recommendDesc: [{
          required: true,
          message: '请输入储值推荐描述',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择类型',
          trigger: 'change'
        }],
        shopids: [{
          required: true,
          message: '请选择门店',
          trigger: 'change',
          validator: this.validateShopIds
        }],
        timeRange: [{
          required: true,
          message: '请选择有效时间',
          trigger: 'change',
          validator: this.validateTimeRange
        }]
      },
      // 搜索表单
      searchForm: {
        name: ''
      },
      // 门店数据
      storeList: []
    };
  },
  created: function created() {
    // 组件创建时可以访问到传入的key值
    console.log('StoredValuePopupConfiguration - pageKey:', this.pageKey, 'moduleKey:', this.moduleKey);
    // 页面加载时获取已保存的配置
    this.loadConfig();
    // 获取门店数据
    this.loadStoreAndRegionData();
  },
  methods: {
    handleTypeChange: function handleTypeChange() {
      this.formData.shopids = []; // 更改类型后清空shopids
    },
    // 切换分类时清空储值档位值（描述类型不需要储值档位）
    handleCategoryChange: function handleCategoryChange() {
      if (this.formData.category === 1) {
        this.formData.name = '';
      }
      // 清除该字段的校验状态
      if (this.$refs.form) {
        this.$refs.form.clearValidate('name');
      }
    },
    // 储值档位校验：仅当分类为储值档位时必填
    validateName: function validateName(rule, value, callback) {
      if (this.formData.category === 0) {
        if (!value) {
          callback(new Error('请输入储值档位'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    // 加载配置 - 使用通用配置项接口
    loadConfig: function () {
      var _loadConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (!(!this.pageKey || !this.moduleKey)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              // 显示加载loading状态
              this.loading = true;

              // 调用通用配置项列表接口
              _context.next = 2;
              return (0, _decorateConfigItem.getDecorateConfigItem)(this.pageKey, this.moduleKey, this.currentPage, this.pageSize, this.searchForm.name);
            case 2:
              response = _context.sent;
              // 关闭loading
              this.loading = false;
              if (response.code === 200 && response.records) {
                // 解析配置信息 - extra 字段存储业务字段的 JSON 字符串
                this.list = response.records.map(function (item) {
                  // 解析 extra 中的业务字段
                  var extra = {};
                  try {
                    extra = item.extra ? JSON.parse(item.extra) : {};
                  } catch (e) {
                    console.error('解析extra失败:', e);
                  }
                  return {
                    id: item.id,
                    name: item.title || '',
                    // title 对应储值档位
                    recommendDesc: extra.recommendDesc || '',
                    // 储值推荐描述
                    category: extra.category !== undefined ? extra.category : 0,
                    // 分类：0-储值档位 1-描述
                    type: extra.type !== undefined ? extra.type : 0,
                    // 类型
                    shopids: extra.shopids || [],
                    // 门店ID集合
                    enable: item.enable !== undefined ? item.enable : false,
                    startTime: extra.startTime || '',
                    // 开始时间（时间戳）
                    endTime: extra.endTime || '',
                    // 结束时间（时间戳）
                    createTime: item.createTime || '',
                    // 创建时间
                    updateTime: item.updateTime || '' // 更新时间
                  };
                });
                this.total = response.total;
              } else if (response.code !== 200) {
                this.$message.error(response.message || '配置加载失败!');
              }
              // 如果response.records为空，说明还没有保存过配置，使用默认值
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](0);
              // 关闭loading
              this.loading = false;
              console.error('配置加载失败:', _t);
              this.$message.error('配置加载失败: ' + (_t.message || '未知错误'));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 3]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }(),
    // 新增
    handleAdd: function handleAdd() {
      this.dialogTitle = '新增储值档位';
      this.isEdit = false;
      this.currentId = null;

      // 初始化表单数据
      this.formData = {
        name: '',
        recommendDesc: '',
        category: 0,
        type: 0,
        // 默认为0
        enable: true,
        shopids: [] // 初始化为空数组
      };

      // 初始化时间范围
      this.timeRange = [];
      this.dialogVisible = true;
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      this.dialogTitle = '编辑储值档位';
      this.isEdit = true;
      this.currentId = row.id;

      // 填充表单数据（列表数据已解析过 extra）
      this.formData = {
        name: row.name || '',
        recommendDesc: row.recommendDesc || '',
        category: row.category !== undefined ? row.category : 0,
        type: row.type !== undefined ? row.type : 0,
        enable: row.enable !== undefined ? row.enable : true,
        shopids: Array.isArray(row.shopids) ? (0, _toConsumableArray2.default)(row.shopids) : []
      };

      // 设置时间范围 - 将时间戳转换为日期对象
      if (row.startTime || row.endTime) {
        var startDate = row.startTime ? new Date(parseInt(row.startTime)) : null;
        var endDate = row.endTime ? new Date(parseInt(row.endTime)) : null;
        this.timeRange = [startDate, endDate];
      } else {
        this.timeRange = [];
      }
      this.dialogVisible = true;
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this = this;
      this.$confirm('确定要删除该储值档位吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _decorateConfigItem.deleteConfigItem)(row.id);
            case 1:
              response = _context2.sent;
              if (!(response.code === 200)) {
                _context2.next = 3;
                break;
              }
              _this.$message.success('删除成功');
              // 重新加载数据
              _context2.next = 2;
              return _this.loadConfig();
            case 2:
              _context2.next = 4;
              break;
            case 3:
              _this.$message.error(response.message || '删除失败!');
            case 4:
              _context2.next = 6;
              break;
            case 5:
              _context2.prev = 5;
              _t2 = _context2["catch"](0);
              console.error('删除失败:', _t2);
              _this.$message.error('删除失败: ' + (_t2.message || '未知错误'));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 5]]);
      }))).catch(function () {
        _this.$message.info('已取消删除');
      });
    },
    // 状态切换 - 使用通用启用/禁用接口（后端自动取反）
    handleStatusChange: function () {
      var _handleStatusChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _decorateConfigItem.enableConfigItem)(row.id);
            case 1:
              response = _context3.sent;
              if (!(response.code === 200)) {
                _context3.next = 3;
                break;
              }
              this.$message.success('状态更新成功');
              // 重新加载数据
              _context3.next = 2;
              return this.loadConfig();
            case 2:
              _context3.next = 4;
              break;
            case 3:
              this.$message.error(response.message || '状态更新失败!');
              // 恢复状态
              row.enable = !row.enable;
            case 4:
              _context3.next = 6;
              break;
            case 5:
              _context3.prev = 5;
              _t3 = _context3["catch"](0);
              console.error('状态更新失败:', _t3);
              this.$message.error('状态更新失败: ' + (_t3.message || '未知错误'));
              // 恢复状态
              row.enable = !row.enable;
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 5]]);
      }));
      function handleStatusChange(_x) {
        return _handleStatusChange.apply(this, arguments);
      }
      return handleStatusChange;
    }(),
    // 提交表单 - 使用通用配置项保存接口
    submitForm: function submitForm() {
      var _this2 = this;
      this.$refs.form.validate(/*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(valid) {
          var startTimeStamp, endTimeStamp, extraData, data, loading, response, _t4;
          return regeneratorRuntime.wrap(function (_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (!valid) {
                  _context4.next = 10;
                  break;
                }
                _context4.prev = 1;
                // 将时间转换为时间戳
                startTimeStamp = null;
                endTimeStamp = null; // 如果时间范围有值，则从中提取时间戳
                if (_this2.timeRange && _this2.timeRange.length === 2) {
                  startTimeStamp = _this2.timeRange[0] ? new Date(_this2.timeRange[0]).getTime() : null;
                  endTimeStamp = _this2.timeRange[1] ? new Date(_this2.timeRange[1]).getTime() : null;
                }

                // 业务字段打包到 extra（JSON 字符串）
                extraData = {
                  recommendDesc: _this2.formData.recommendDesc,
                  category: _this2.formData.category,
                  type: _this2.formData.type,
                  shopids: _this2.formData.shopids,
                  startTime: startTimeStamp,
                  endTime: endTimeStamp
                }; // 构造通用配置项保存数据
                data = {
                  title: _this2.formData.name,
                  // 名称对应 title
                  pageCode: _this2.pageKey,
                  optionCode: _this2.moduleKey,
                  enable: _this2.formData.enable,
                  extra: JSON.stringify(extraData)
                }; // 编辑时带上 id
                if (_this2.isEdit) {
                  data.id = _this2.currentId;
                }

                // 显示保存loading状态
                loading = _this2.$loading({
                  lock: true,
                  text: '保存中...',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                _context4.prev = 2;
                _context4.next = 3;
                return (0, _decorateConfigItem.saveConfigItem)(data);
              case 3:
                response = _context4.sent;
                if (!(response.code === 200)) {
                  _context4.next = 5;
                  break;
                }
                _this2.$message.success(_this2.isEdit ? '编辑成功' : '新增成功');
                // 重新加载数据
                _this2.dialogVisible = false;
                _context4.next = 4;
                return _this2.loadConfig();
              case 4:
                _context4.next = 6;
                break;
              case 5:
                _this2.$message.error(response.message || '保存失败!');
              case 6:
                _context4.prev = 6;
                // 确保loading总是被关闭
                loading.close();
                return _context4.finish(6);
              case 7:
                _context4.next = 9;
                break;
              case 8:
                _context4.prev = 8;
                _t4 = _context4["catch"](1);
                console.error('保存失败:', _t4);
              case 9:
                _context4.next = 11;
                break;
              case 10:
                console.log('表单验证失败!');
                return _context4.abrupt("return", false);
              case 11:
              case "end":
                return _context4.stop();
            }
          }, _callee4, null, [[1, 8], [2,, 6, 7]]);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    // 处理对话框关闭
    handleDialogClose: function handleDialogClose() {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadConfig();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadConfig();
    },
    // 处理时间范围变化
    handleTimeRangeChange: function handleTimeRangeChange(value) {
      // 直接将值保存到timeRange变量中，时间戳转换将在提交时进行
    },
    // 查询方法
    query: function query() {
      this.currentPage = 1;
      this.loadConfig();
    },
    // 获取门店数据
    loadStoreAndRegionData: function () {
      var _loadStoreAndRegionData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var storeResponse, _t5;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 1;
              return (0, _shopList.getStoreAllData)();
            case 1:
              storeResponse = _context5.sent;
              if (storeResponse.code === 200 && storeResponse.data) {
                this.storeList = storeResponse.data;
              }
              _context5.next = 3;
              break;
            case 2:
              _context5.prev = 2;
              _t5 = _context5["catch"](0);
              console.error('获取门店数据失败:', _t5);
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function loadStoreAndRegionData() {
        return _loadStoreAndRegionData.apply(this, arguments);
      }
      return loadStoreAndRegionData;
    }(),
    // 验证门店是否已选择
    validateShopIds: function validateShopIds(rule, value, callback) {
      if (this.formData.type === 1) {
        if (!value || value.length === 0) {
          callback(new Error('请选择门店'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    // 验证有效时间是否已选择
    validateTimeRange: function validateTimeRange(rule, value, callback) {
      if (!this.timeRange || this.timeRange.length !== 2 || !this.timeRange[0] || !this.timeRange[1]) {
        callback(new Error('请选择有效时间'));
      } else {
        callback();
      }
    },
    // 根据ID获取门店名称
    getStoreNameById: function getStoreNameById(id) {
      var store = this.storeList.find(function (item) {
        return item.storeId === id;
      });
      return store ? store.storeName : '';
    },
    // 获取门店名称字符串
    getStoreNames: function getStoreNames(shopIds) {
      var _this3 = this;
      var ids = this.parseShopIds(shopIds);
      return ids.map(function (id) {
        return _this3.getStoreNameById(id);
      }).join(', ');
    },
    // 解析shopids字符串为数组
    parseShopIds: function parseShopIds(shopIds) {
      if (!shopIds) return [];

      // 如果是数组格式，直接返回
      if (Array.isArray(shopIds)) return shopIds;

      // 如果是字符串格式，如 "[1,2]"
      if (typeof shopIds === 'string') {
        try {
          return JSON.parse(shopIds);
        } catch (e) {
          return [];
        }
      }
      return [];
    }
  }
};